/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
import React from 'react';
import PropTypes from 'prop-types';

const ItemTitle = (props) => {
    const { i18n } = props;
    return (
            <div className={"appoint-itemTitle-body"}>
                <div data-key={i18n.dataKey + "-header"} className="itemTitle">{i18n.title}</div>
                <div data-key={i18n.dataKey + "-dec"}>{i18n.dec}</div>
            </div>
    )
};
ItemTitle.propTypes = {
    title: PropTypes.string,
    dec: PropTypes.string,
    dataKey: PropTypes.string
};
export default ItemTitle;





// WEBPACK FOOTER //
// ./src/views/Appointment/components/ItemTitle.js